// extracted by mini-css-extract-plugin
module.exports = {"container":"ModelSearch_container__3oLtl","searchInputContainer":"ModelSearch_searchInputContainer__1fzrr","searchInput":"ModelSearch_searchInput__W5tif"};